<template>
  <div>
    <b-card>
      <b-row class="mb-0">
        <b-col md="3">
          <b-form-group label="Folio">
            <b-form-input
              v-model="filters[0].value"
              placeholder="Buscar por Folio"
              @input="advanceSearch"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          class="mb-1"
        >
          <b-form-group label="CURP">
            <b-form-input
              v-model="filters[1].value"
              placeholder="Buscar por CURP"
              @input="advanceSearch"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="opcEstadoSolicitud"
          md="3"
        >
          <b-form-group label="Género">
            <v-select
              v-model="filters[2].value"
              label="descripcion"
              :reduce="opc => opc.id"
              placeholder="selecciona una opción"
              :options="opcGenero"
              @input="advanceSearch"
              @option:deselected="advanceSearch"
            >
              <template slot="no-options">
                No hay registros.
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          v-if="opcEstadoSolicitud"
          md="3"
        >
          <b-form-group label="Nivel de Estudios">
            <v-select
              v-model="filters[3].value"
              label="descripcion"
              :reduce="opc => opc.id"
              placeholder="selecciona una opción"
              :options="opcNivelEstudios"
              @input="advanceSearch"
              @option:deselected="advanceSearch"
            >
              <template slot="no-options">
                No hay registros.
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Edad">
            <b-form-input
              v-model="age"
              placeholder="Filtrar por Edad"
              @input="filterAge"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="opcEstadoSolicitud"
          md="3"
        >
          <b-form-group label="Estado Solicitud">
            <v-select
              v-model="filters[5].value"
              label="descripcion"
              :reduce="opc => opc.id"
              placeholder="selecciona un estado solicitud"
              :options="opcEstadoSolicitud"
              :disabled="disabled"
              @input="advanceSearch"
              @option:deselected="advanceSearch"
            >
              <template slot="no-options">
                No hay registros.
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          v-if="opcEstadoSolicitud"
          md="6"
        >
          <b-form-group label="Convocatoria">
            <v-select
              v-model="filters[6].value"
              label="convocatoria_nombre"
              :reduce="opc => opc.convocatoria_id"
              placeholder="selecciona un tipo de convocatoria"
              :options="opcTipoConvocatoria"
              @input="advanceSearch"
              :clearable="false"
            >
              <!-- @option:deselected="advanceSearch" -->
              <template slot="no-options">
                No hay registros.
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-row v-if="rows">
      <b-col cols="3">
        <statistic-card
          icon="UsersIcon"
          color="success"
          :statistic="total"
          statistic-title="Total Aspirantes"
        />
      </b-col>
      <b-col cols="3">
        <statistic-card
          icon="UserIcon"
          color="info"
          :statistic="aspirantesFemeninos"
          statistic-title="Aspirantes Femeninos"
        />
      </b-col>
      <b-col cols="3">
        <statistic-card
          icon="UserIcon"
          color="secondary"
          :statistic="aspirantesMasculinos"
          statistic-title="Aspirantes Masculinos"
        />
      </b-col>
      <b-col cols="3">
        <button-card
          icon="DownloadIcon"
          color="primary"
          :filter="listQuery.filter"
        />
      </b-col>
    </b-row>

    <b-card>
      <!-- table -->
      <!-- mode="remote" -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :total-rows="total"
        :is-loading.sync="isLoading"
        :line-numbers="false"
        :pagination-options="{
          enabled: true,
          perPage: listQuery.limit,
          nextLabel: 'sig',
          prevLabel: 'ant',
          rowsPerPageLabel: 'registros por página',
        }"
        :sort-options="{
          enabled: true,
        }"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-per-page-change="onPerPageChange"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <!-- Column: Name -->
          <span
            v-if="props.column.field === 'nombre'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{ getFullName(props.row) }}</span>
          </span>

          <!-- Column: Fecha registro -->
          <span
            v-else-if="props.column.field === 'fecha_registro'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{
              formatDate(props.row.fecha_registro)
            }}</span>
          </span>

          <!-- Column: Experiencia anterior -->
          <span v-else-if="props.column.field === 'experiencia_anterior'">
            <b-avatar
              :variant="experienciaVariant(props.row.experiencia_anterior.id)"
            >
              <feather-icon
                :icon="experienciaIcon(props.row.experiencia_anterior.id)"
              />
            </b-avatar>
          </span>

          <!-- Column: Status -->
          <span
            v-else-if="props.column.field === 'solicitud.estatus_solicitud.id'"
          >
            <b-badge
              :id="`detalles-solicitud-${props.row.curp}`"
              :variant="statusVariant(props.row.solicitud.estatus_solicitud.id)"
            >
              <feather-icon
                v-if="
                  props.row.solicitud.detalles &&
                    props.row.solicitud.estatus_solicitud.id === 1
                "
                icon="AlertCircleIcon"
                class="mr-25"
              />
              <b-tooltip
                v-if="
                  props.row.solicitud.detalles &&
                    props.row.solicitud.estatus_solicitud.id === 1
                "
                :title="props.row.solicitud.detalles"
                :target="`detalles-solicitud-${props.row.curp}`"
              />
              {{ props.row.solicitud.estatus_solicitud.descripcion }}
              <!-- {{ props.row }} -->
            </b-badge>
            <!-- <b-badge variant="primary">
            Pendiente
          </b-badge> -->
          </span>
          <!-- Column: Tipo Convocatoria -->
          <span
            v-else-if="props.column.field === 'solicitud.tipo_convocatoria.id'"
          >
            <!-- <b-badge
              :variant="statusVariant(props.row.solicitud.tipo_convocatoria.id)"
            >
            </b-badge> -->
              {{ props.row.solicitud.tipo_convocatoria.nombre }}
          </span>

          <!-- Column: Action -->
          <div v-else-if="props.column.field === 'action'">
            <b-button
              variant="flat"
              size="sm"
              @click="
                $router.push({
                  name: 'prebecario-detalles',
                  params: {
                    id: props.row.id,
                    curp: props.row.curp,
                    mode: false,
                  },
                })
              "
            >
              <feather-icon
                :id="`invoice-row-${props.row.curp}-preview-icon`"
                icon="EyeIcon"
                size="16"
                class="mx-1"
              />
              <span>Detalles</span>
              <b-tooltip
                title="Detalles Prebecario"
                :target="`invoice-row-${props.row.curp}-preview-icon`"
              />
            </b-button>
          </div>
        </template>

        <!-- pagination -->
        <template
          slot="pagination-bottom"
          slot-scope="props"
        >
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                Visualizando 1 a
              </span>
              <b-form-select
                v-model="listQuery.limit"
                :options="['10', '25', '50']"
                class="mx-1"
                @input="
                  value => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> de {{ props.total }} registros </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="listQuery.limit"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="value => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
        <div
          slot="emptystate"
          class="text-center"
        >
          No hay datos para mostrar.
        </div>
        <div
          slot="loadingContent"
          class="text-center"
        >
          <span class="vgt-loading__content"> cargando registros... </span>
        </div>
      </vue-good-table>
    </b-card>
  </div>
</template>

<script>
// import store from '@/store/index'
import { mapGetters } from 'vuex'

import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BRow,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import vSelect from 'vue-select'
import { VueGoodTable } from 'vue-good-table'
import moment from 'moment'
import PrebecariosService from '@/services/PrebecariosService'
import CatalogosService from '@/services/CatalogosService'
import StatisticCard from './components/StatisticCard.vue'
import ButtonCard from './components/ButtonCard.vue'

export default {
  name: 'Prebecarios',
  directives: { Ripple },
  components: {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCol,
    BRow,
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    vSelect,
    BTooltip,
    StatisticCard,
    ButtonCard,
  },
  props: {
    status: {
      type: Number,
      default: null,
    },
    details: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disabled: false,
      isLoading: true,
      rows: [],
      searchTerm: '',
      total: 0,
      listQuery: {
        limit: 10,
        page: 1,
        ordering: null,
        filter: {},
      },
      columns: [
        {
          label: 'Folio',
          field: 'solicitud.folio',
        },
        {
          label: 'CURP',
          field: 'curp',
        },
        {
          label: 'Nombre completo',
          field: 'nombre',
        },
        {
          label: 'Género',
          field: 'sexo.descripcion',
        },
        {
          label: 'Fecha Registro',
          field: 'fecha_registro',
        },
        {
          label: 'Estado Solicitud',
          field: 'solicitud.estatus_solicitud.id',
          sortable: false,
        },
        {
          label: 'Tipo Convocatoria',
          field: 'solicitud.tipo_convocatoria.id',
          sortable: false,
        },
        {
          label: 'Acciones',
          field: 'action',
          sortable: false,
        },
      ],
      filters: [
        {
          field: 'folio',
          value: null,
        },
        {
          field: 'curp',
          value: null,
        },
        {
          field: 'genero',
          value: null,
        },
        {
          field: 'nivel_estudios',
          value: null,
        },
        {
          field: 'edad',
          value: null,
        },
        {
          field: 'estatus_solicitud',
          value: null,
        },
        {
          field: 'tipo_convocatoria',
          value: null,
        },
        {
          field: 'detalles',
          value: null,
        },
        {
          field: 'sin_detalles',
          value: null,
        },
      ],
      age: null,
      aspirantesFemeninos: 0,
      aspirantesMasculinos: 0,
      opcGenero: [],
      opcNivelEstudios: [],
      opcEstadoSolicitud: [],
      opcTipoConvocatoria: [],
      user: null,
      su: null,
    }
  },
  computed: {
    getFullName() {
      return row => `${row.nombre} ${row.apellido_paterno} ${row.apellido_materno}`
    },
    statusVariant() {
      const statusColor = { 1: 'primary', 2: 'success', 3: 'danger' }
      return status => statusColor[status]
    },
    formatDate() {
      return fecha => moment(fecha).format('YYYY-MM-DD')
      // return fechaRegistro => moment(fechaRegistro).form|at('YYYY-MM-DD HH:mm')
    },
    experienciaVariant() {
      const experienciaColor = { 1: 'danger', 2: 'success' }
      return experiencia => experienciaColor[experiencia]
    },
    experienciaIcon() {
      const icons = { 1: 'XCircleIcon', 2: 'CheckCircleIcon' }
      return experiencia => icons[experiencia]
    },
    ageToYear() {
      return age => moment()
        .subtract(age, 'years')
        .format('YYYY')
    },
  },
  async mounted() {
    this.fetchCatGenero()
    this.fetchNivelEstudios()
    this.fetchCatEstatusSolicitud()
    const { id } = this.getDataUser()
    this.user = id
    const resp = await this.fetchConvByUser()
    // this.fetchCatTipoConvocatoria()

    if (this.status === 1) {
      if (this.details) {
        this.filters[7].value = 'isnull'
      } else {
        this.filters[8].value = 'notnull'
      }
    }
    this.disabled = true
    this.filters[5].value = this.status
    if (resp > 0) {
      this.filters[6].value = this.opcTipoConvocatoria[0].convocatoria_id
      this.advanceSearch()
    }
  },
  methods: {
    ...mapGetters('user', ['getDataUser']),
    updateParams(newProps) {
      this.listQuery = { ...this.listQuery, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.fetchListPrebecarios()
    },
    onPerPageChange(params) {
      this.updateParams({ limit: params.currentPerPage })
      this.fetchListPrebecarios()
    },
    updateSort(params) {
      const orderings = params.map(elem => (elem.type === 'desc' ? `-${elem.field}` : elem.field))
      return orderings.join()
    },
    updateFilter() {
      const myFilter = {}
      this.filters.forEach(element => {
        if (element.value) {
          myFilter[element.field] = element.value
        }
      })
      this.listQuery.filter = myFilter
    },
    onSortChange(params) {
      const orderins = this.updateSort(params)
      this.updateParams({ orderins })
      this.updateFilter()
      this.fetchListPrebecarios()
    },
    advanceSearch() {
      if (this.opcTipoConvocatoria.length !== 0) {
        this.updateFilter()
        this.fetchListPrebecarios()
      }
    },
    fetchCatEstatusSolicitud() {
      CatalogosService.getCatEstatusSolicitud().then(response => {
        this.opcEstadoSolicitud = response.data
        // this.filters[5] = this.status
      })
    },
    fetchCatTipoConvocatoria() {
      CatalogosService.getCatConvocatoria().then(response => {
        this.opcTipoConvocatoria = response.data
      })
    },
    async fetchConvByUser() {
      const response = await CatalogosService.getConvByUser({ usuario: this.user })
      if (response.data) {
        const { data } = response
        this.opcTipoConvocatoria = data
        return data.length
      }
      return 0
    },
    fetchCatGenero() {
      CatalogosService.getCatPubGenero().then(response => {
        this.opcGenero = response.data
      })
    },
    fetchNivelEstudios() {
      CatalogosService.getCatNivelEstudios().then(response => {
        this.opcNivelEstudios = response.data
      })
    },
    fetchListPrebecarios() {
      const vm = this
      vm.isLoading = true
      PrebecariosService.listPrebecarios(vm.listQuery)
        .then(response => {
          if (response && response.status === 200) {
            const { count, results } = response.data
            vm.total = count
            vm.rows = results.prebecarios
            const { femeninos, masculinos } = results.estadisticas
            vm.aspirantesFemeninos = femeninos
            vm.aspirantesMasculinos = masculinos
          }
        })
        .finally(() => {
          setTimeout(() => {
            vm.isLoading = false
          }, 500)
        })
    },
    filterAge() {
      this.filters[4].value = this.age ? this.ageToYear(this.age) : null
      this.advanceSearch()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
